import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useInvestorAuth } from '../../context/InvestorAuthContext';
import InvestorPortalNav from './InvestorPortalNav';

export default function InvestorPortalLayout({ children }) {
  const { investor, investorLoading } = useInvestorAuth();
  const location = useLocation();
  if (investorLoading) return null;
  if (!investor) {
    return <Navigate to="/market/login" state={{ from: location.pathname }} replace />;
  }
  return <InvestorPortalNav>{children}</InvestorPortalNav>;
}
